module.exports = __webpack_public_path__ + "static/media/AWT Mask Video_1613826955017.aaf7b8e4.docx";